import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { Table, Typography, Button, Flex, Tag } from "antd"
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"
import styles from "../../index.module.css"
import { spacings } from "themes/variables"

const { Text } = Typography

export const EquipmentTable = ({ data, onEdit, onRemove }) => {
  // Memoize columns to prevent recreation on every render
  const columns = useMemo(
    () => [
      {
        title: "Equipment Name",
        dataIndex: "name",
        key: "name",
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (name) => <Text fw="500">{name}</Text>
      },
      {
        title: "Category",
        dataIndex: "category",
        key: "category",
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (category) => <Text>{category?.name || "-"}</Text>
      },
      {
        title: "Quantity",
        key: "quantity",
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (_, record) => (
          <Tag color="blue" bordered>
            QTY: {record.quantity ?? 0}
          </Tag>
        )
      },
      {
        title: "Actions",
        key: "action",
        align: "right",
        onHeaderCell: () => ({ className: styles.tableHeaderCell }),
        render: (_, record) => (
          <Flex gap={spacings.XS} justify="end">
            <Button
              type="text"
              icon={<EditOutlined className={styles.editIcon} />}
              onClick={() => onEdit(record)}
              aria-label="Edit equipment"
            />
            <Button
              type="text"
              icon={<DeleteOutlined className={styles.deleteIcon} />}
              onClick={() => onRemove(record.id)}
              className={styles.removeExperienceButton}
              aria-label="Remove equipment"
            />
          </Flex>
        )
      }
    ],
    [onEdit, onRemove]
  )

  return <Table className={styles.equipmentTable} dataSource={data} rowKey="id" pagination={false} columns={columns} scroll={{ y: 300 }} />
}

EquipmentTable.propTypes = {
  data: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
}
